module.exports = __webpack_public_path__ + "static/media/preventivo_verde.1d6d51aa.svg";